import { useState } from 'react';
import { Music2 } from 'lucide-react';

/**
 * <ArtistImage>
 *
 * Renders the artist's photo with a graceful fallback when the underlying
 * image URL is missing, broken, or 404s. Many of our seeded artist photos
 * still point at third-party CDNs that occasionally disappear; this stops
 * the browser's broken-image icon from leaking through to buyers.
 *
 * Falls back to a dark surface tile with the artist's initial in lime.
 */
export function ArtistImage({ src, alt, name, className = '' }) {
  const [errored, setErrored] = useState(false);
  const initial = (name || '?').trim().charAt(0).toUpperCase();

  if (!src || errored) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] ${className}`}
        data-testid="artist-image-fallback"
        aria-label={alt}
      >
        <div className="flex flex-col items-center text-center px-2">
          <span className="font-heading font-bold text-5xl sm:text-6xl text-lime/70 leading-none">
            {initial}
          </span>
          <Music2 className="w-5 h-5 text-lime/40 mt-3" />
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      className={className}
      loading="lazy"
    />
  );
}
